<template>
  <div class="business_content">
    <div class="business_content_box" v-for="board in boardData" :key="`business${board.wr_id}`"
         @click="goDetail(board.wr_id)">
      <img class="business_content_box_img" :src="returnImage(board)">
      <div class="business_content_box_textBox">
        <div class="business_content_box_textBox_title">{{ board.wr_subject }}</div>
        <div class="business_content_box_textBox_text" v-html="decodeHtml(board.wr_content)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";


export default {
  name: "BoardListBusinessLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      if (!util.isEmpty(board.File.MobileFile[0])) {
        return `${board.File.MobileFile[0].org_url}?${this.setImageOptions(256, 184, 'jpg')}`;
      }
    },
    decodeHtml(html = '') {
      let img_tag = /<IMG(.*?)>/gi;
      let video_tag = /<iframe(.*?)>(.*?)<\/iframe>/gi;
      html = html.replace(img_tag, "");
      html = html.replace(video_tag, "");

      return util.htmlDecode(html);
    },
    goDetail(idx) {
      this.$router.push(`/business/${idx}`)
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
